import { render, staticRenderFns } from "./SubtitlesInfoBox.vue?vue&type=template&id=472ce296&scoped=true"
import script from "./SubtitlesInfoBox.vue?vue&type=script&lang=js"
export * from "./SubtitlesInfoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472ce296",
  null
  
)

/* custom blocks */
import block0 from "./SubtitlesInfoBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports